// The forgot-password endpoint returns HTTP 200 even on failures; success vs
// failure is conveyed by the CommonResponse `code`. This mirrors the server's
// RespCodes.isSuccess, which treats 2000 / 200 / 0 as success and anything else
// (e.g. 4002 INVALID_USER_ID) as an error where no email was actually sent.
export const isSuccessResponse = (code) =>
  code === 2000 || code === 200 || code === 0

// Cooldown (seconds) between password-reset email resends. The success screen
// starts on this cooldown because an email was just sent to reach it, and the
// cooldown restarts after each successful resend to prevent spamming.
export const RESEND_COOLDOWN_SECONDS = 30
